import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<nb-chip-row>` — horizontal scroll container for `<nb-chip>` (Mockup `.chiprow`).
 *
 * Lays chips out in a single row with an 8px gap that scrolls horizontally when
 * it overflows; the scrollbar is hidden to match the mockup. Exposed as a
 * `group` so the set of filter chips reads as one control to assistive tech.
 *
 * @example
 * <nb-chip-row aria-label="Filtre">
 *   <nb-chip [(selected)]="a">Alle</nb-chip>
 *   <nb-chip [(selected)]="b">Verktøy</nb-chip>
 * </nb-chip-row>
 */
@Component({
  selector: 'nb-chip-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'group',
  },
  template: `<ng-content />`,
  styleUrl: './chip-row.css',
})
export class NbChipRow {}
